import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.games.games,
    props.modals_action.data.welcome_package,
    props.user.welcome_bonus,
    (games, data, welcome_bonus, user) => {
        const game_slug = welcome_bonus.details?.game || data.game,
              game = games.filter(g => g.slug === game_slug)[0] || false;

        return {
            game
        }
    }
)